import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _RequestMaintenance, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}


interface Props {
    configProcedure: ProcedureFunctions;
}

export const MD003 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean } = useDataBean(_RequestMaintenance);
    const [props, setProps] = useState<any>({});
    const [request, setRequest] = useState<any>({});

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    useEffect(() => {
        instance.getRequestMaintenanceCatalogPorPropiedades({ IDProceudreIMP: props.IDProceudreIMP }, null).then(
            (resp) => {
                if (resp?.length > 0 && resp[0].DataBeanProperties) {
                    setRequest(resp[0].DataBeanProperties);
                }
            }
        ).catch(
            err => { console.log("No se pudo cargar la informacion") }
        )
    }, [props])

    const onExportMap = (obj?: any) => {
        const tiposMantenimiento: Record<string, string> = {
            Calibration: "Requiere Calibración/Ajuste",
            Replacement: "Requiere Repuesto",
            NA: "N/A o no presenta falla"
        };

        const tipoMantenimientoTexto = tiposMantenimiento[bean.Type] || "No especificado";
        const pad = (num: number) => num.toString().padStart(2, '0');

        instance.updateRequestMaintenance({
            ...request,
            State: bean.type == "NA" ? 4 : 3,
            ReviewFromH: bean.ReviewFromH,
            ReviewFromM: bean.ReviewFromM,
            ReviewDate: _single.getCurrenDate(),
            DescriptionOperator: bean.DescriptionOperator,
            CodeTurno: bean.CodeTurno
        }).then(() => {
            if (configProcedure?._pushInfo) {
                configProcedure._pushInfo(

                    _single.jsonToBootstrapTable({
                        "Tipo de Mantenimiento": tipoMantenimientoTexto,
                        "Hora de Actividad": `${pad(bean.ReviewFromH ?? 0)}:${pad(bean.ReviewFromM ?? 0)}`,
                        "COdigo de Turno": bean.CodeTurno,
                        "Observación del Técnico": bean.DescriptionOperator,
                    })
                );
            }

            if (configProcedure?._exportMap) {
                configProcedure._exportMap(bean);
            }
        }).catch(() => {
            toast.error("No se pudo realizar la acción");
        });
    };



    return (
        <div className="row">
            <div className="col-md-6">
                <label>Hora en que se Ejectura la actividad</label>
                <div className="row">
                    <div className="col-md-6">
                        <select
                            className="form-control"
                            value={bean.ReviewFromH ?? ""}
                            onChange={(e) => setBean({ ...bean, ReviewFromH: parseInt(e.target.value) })}
                        >
                            <option value="">HH</option>
                            {[...Array(24)].map((_, i) => (
                                <option key={i} value={i}>{i.toString().padStart(2, '0')}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-6">
                        <select
                            className="form-control"
                            value={bean.ReviewFromM ?? ""}
                            onChange={(e) => setBean({ ...bean, ReviewFromM: parseInt(e.target.value) })}
                        >
                            <option value="">MM</option>
                            {[...Array(12)].map((_, i) => (
                                <option key={i * 5} value={i * 5}>{(i * 5).toString().padStart(2, '0')}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>

            <div className="col-md-6">
                <label>Tipo de Mantenimiento a realizar</label>
                <select className="form-select" value={bean.Type} onChange={(e) => { setBean({ ...bean, Type: e.target.value }) }}  >
                    <option value="">...</option>
                    <option value="Calibration">Requiere Calibración/Ajuste</option>
                    <option value="Replacement">Requiere Repuesto</option>
                    <option value="NA">N/A o no presenta falla</option>
                </select>
            </div>
            <div className="col-md-6">
                <label>Codigo del Turno</label>
                <select className="form-select" value={bean.CodeTurno} onChange={(e) => { setBean({ ...bean, CodeTurno: e.target.value }) }}  >
                    <option value="">...</option>
                    <option value="A">A</option>
                    <option value="B">B</option>
                </select>
            </div>
            <div className="col-md-12">
                <label>Error Evidenciado (Tecnico)</label>
                <textarea className="form-control" value={bean.DescriptionOperator} onChange={(e) => { setBean({ ...bean, DescriptionOperator: e.target.value }) }} />
            </div>
            <div className="col-md-12 mt-4">
                <BasicButton eventClick={onExportMap} icon="ri-send-plane-line" children={`Enviar Informe`} />
            </div>
        </div>
    )
}